import { useCallback } from 'react'

import { useActivePaymentProfile } from './use-active-payment-profile'

/**
 * Liga um `PaymentProfileFilter mode="single"` à loja ativa global (`useActivePaymentProfile`).
 * O componente segue controlled; este adapter concentra o store e o mapeamento single ↔ `[id]`.
 */
export function useActivePaymentProfileBinding() {
  const { activeProfileId, setActiveProfile, clear } = useActivePaymentProfile()

  const onChange = useCallback(
    (ids: string[]) => (ids[0] ? setActiveProfile(ids[0]) : clear()),
    [setActiveProfile, clear]
  )

  return { value: activeProfileId ? [activeProfileId] : [], onChange }
}
